import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TeamInsightVm} from '../../models/team-dynamic-team.vm';

@Component({
  selector: 'app-team-insights',
  templateUrl: './team-insights.component.html',
  styleUrls: ['./team-insights.component.scss']
})
export class TeamInsightsComponent {
  @Input() insights: TeamInsightVm[] = [];

  @Output() dismissed = new EventEmitter<TeamInsightVm>();
  @Output() seeAllClicked = new EventEmitter<void>();

  onDismiss(insight: TeamInsightVm) {
    this.dismissed.emit(insight);
  }

  onSeeAll() {
    this.seeAllClicked.emit();
  }

  trackByUuid(index: number, insight: TeamInsightVm) {
    return insight.uuid ?? index;
  }
}
